import React from 'react'
import { HashRouter, Route, Routes } from 'react-router-dom'

import NFTConsole from '../themes/nft-console'

export default function AppRoutes() {
  return (
    <HashRouter>
      <Routes>
        <Route path="/:chain/:contract" element={<NFTConsole />} />
        <Route path="*" element={<main className="console-route-error">Open this console from a valid FatSale NFT contract link.</main>} />
      </Routes>
    </HashRouter>
  )
}
